/**
 * charm-multi-picker.js
 *
 * Gestisce la selezione multipla dei charm nella pagina prodotto.
 * - Aggiorna il prezzo visualizzato sommando i charm selezionati
 * - All'aggiunta al carrello, aggiunge l'occhiale + ogni charm come item separato
 *
 * Nessuna dipendenza esterna. Compatibile con Dawn / temi custom Shopify.
 */

(function () {
  'use strict';

  const PICKER_ID = 'charm-multi-picker';
  const SUMMARY_ID = 'charm-multi-price-summary';
  const CHECKBOX_CLASS = 'charm-multi-checkbox';

  // ─── Formattazione prezzo ────────────────────────────────────────────────────
  function formatPrice(cents) {
    return (cents / 100).toLocaleString('it-IT', {
      style: 'currency',
      currency: 'EUR',
    });
  }

  // ─── Aggiorna il riepilogo prezzo charm ─────────────────────────────────────
  function updatePriceSummary() {
    const picker = document.getElementById(PICKER_ID);
    if (!picker) return;

    const checked = picker.querySelectorAll(`.${CHECKBOX_CLASS}:checked`);
    const summary = document.getElementById(SUMMARY_ID);
    if (!summary) return;

    if (checked.length === 0) {
      summary.textContent = '';
      return;
    }

    let total = 0;
    checked.forEach((cb) => {
      total += parseInt(cb.dataset.charmPrice, 10);
    });

    const names = Array.from(checked).map((cb) => cb.dataset.charmName.replace('Hello Kitty ', ''));

    if (checked.length === 1) {
      summary.textContent = `+ ${formatPrice(total)} · ${names[0]}`;
    } else {
      summary.textContent = `+ ${formatPrice(total)} · ${names.join(', ')}`;
    }
  }

  // ─── Intercetta il form prodotto e aggiunge charm via AJAX ──────────────────
  function interceptProductForm() {
  const picker = document.getElementById(PICKER_ID);
  if (!picker) return;

  if (document._charmMultiInit) return;
  document._charmMultiInit = true;

  document.addEventListener('click', async function (e) {
    const picker = document.getElementById(PICKER_ID);
    if (!picker) return;

    const addBtn = e.target.closest('[name="add"]');
    if (!addBtn) return;

    const checked = picker.querySelectorAll(`.${CHECKBOX_CLASS}:checked`);
    if (checked.length === 0) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    addBtn.disabled = true;

    try {
      const variantInput = document.querySelector('product-info input[name="id"]')
        || document.querySelector('form[id^="product-form-"] input[name="id"]');
      if (!variantInput) throw new Error('Variant ID non trovato');
      const variantId = parseInt(variantInput.value, 10);

      // 1. Occhiale principale
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      // 2. Charm selezionati — sequenziale per evitare throttling Shopify
for (const cb of checked) {
  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(cb.value, 10), quantity: 1 }),
  });
}

    window.location.href = '/cart';

    } catch (err) {
      console.error('[charm-multi-picker]', err);
      alert('Errore durante l\'aggiunta al carrello. Riprova.');
    } finally {
      addBtn.disabled = false;
    }

  }, true); // capture phase — prima di Dawn
}

  // ─── Aggiorna il contatore carrello nel header ───────────────────────────────
  async function refreshCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const count = cart.item_count;

      // Aggiorna tutti gli elementi con attributo cart count (Dawn + varianti comuni)
      const selectors = [
        '[data-cart-count]',
        '.cart-count-bubble span:first-child',
        '#cart-icon-bubble span',
        '.header__cart-count',
      ];

      selectors.forEach((sel) => {
        document.querySelectorAll(sel).forEach((el) => {
          el.textContent = count;
        });
      });

      // Mostra la bolla carrello se nascosta
      const bubble = document.querySelector('.cart-count-bubble');
      if (bubble && count > 0) {
        bubble.removeAttribute('hidden');
        bubble.style.display = '';
      }
    } catch (e) {
      // Non critico — il count si aggiornerà al prossimo refresh
    }
  }

  // ─── Init ────────────────────────────────────────────────────────────────────
  function init() {
    const picker = document.getElementById(PICKER_ID);
    if (!picker) return;

    // Listener sui checkbox per aggiornare il riepilogo prezzo
    picker.querySelectorAll(`.${CHECKBOX_CLASS}`).forEach((cb) => {
      cb.addEventListener('change', updatePriceSummary);
    });

    // Intercetta il form
    interceptProductForm();

    // Supporto per temi che caricano il form con ritardo (es. section reload)
    const observer = new MutationObserver(() => {
      interceptProductForm();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();